import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { Observable, catchError, map, switchMap, throwError } from 'rxjs';

import { decryptData, encryptData } from '../helpers';
import { EncryptionBase } from '../models/encryption-base.model';
import { ResponseBase } from '../models/response-base.model';
import { PassphraseService } from '../services/passphrase.service';
import { environment } from 'src/environments/environment';
import { PassphraseResponse } from '../models/passphrase/passphrase.model';

@Injectable()
export class EncryptionInterceptor implements HttpInterceptor {
  constructor(private passphraseService: PassphraseService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('passphrase') || !request.url.startsWith(environment.apiEndpoint)) {
      return next.handle(request);
    }

    const notEncryptParam = request.params.get('notEncrypt');
    const notEncrypt = notEncryptParam === 'true' ? true : false;

    return this.passphraseService.post().pipe(
      map(res => {
        const data: PassphraseResponse[] = res.data;
        const requestPassphrase = data.find(x => x.type === 'request');
        const responsePassphrase = data.find(x => x.type === 'response');

        if (requestPassphrase && responsePassphrase) {

          let requestPayload = null;
          if (notEncrypt) {
            requestPayload = request.body;
          } else {
            requestPayload = encryptData(request.body, requestPassphrase.passphrase);
          }

          return {
            requestPayload: requestPayload,
            responsePassphrase: responsePassphrase.passphrase,
            reqUUID: requestPassphrase.uuid,
            resUUID: responsePassphrase.uuid
          };
        }

        throw new Error();
      }),
      switchMap(encryption => {
        if (encryption.requestPayload) {
          let body: EncryptionBase | object = { payload: encryption.requestPayload };
          if (notEncrypt) {
            body = encryption.requestPayload;
          }
          request = request.clone<EncryptionBase | object>({ body });
        }

        let modifiedParams = request.params;
        if (notEncrypt) {
          modifiedParams = modifiedParams.delete('notEncrypt');
        }

        request = request.clone({
          setHeaders: {
            'Req-UUID': encryption.reqUUID,
            'Res-UUID': encryption.resUUID
          },
          params: modifiedParams
        });
        return next.handle(request).pipe(
          map(event => {
            if (event instanceof HttpResponse && event.body) {
              if (event.body.payload) {
                return event.clone<ResponseBase<unknown>>({
                  body: decryptData(event.body.payload, encryption.responsePassphrase)
                });
              } else {
                if (notEncrypt) {
                  body: event.body
                }
              }
            }

            return event;
          }),
          catchError((error: HttpErrorResponse) => {
            console.log(error);
            if (error.error.payload) {
              return throwError(() => ({
                ...error,
                error: decryptData(error.error.payload, encryption.responsePassphrase)
              }));
            }

            return throwError(() => error);
          })
        );
      })
    );
  }
}


/** Provider for the Encryption Interceptor. */
export const encryptionInterceptorProvider: Provider =
  { provide: HTTP_INTERCEPTORS, useClass: EncryptionInterceptor, multi: true };
